import { createContext } from "react";
import { FirebaseApp } from "firebase/app";
import { Auth } from "firebase/auth";
import { FirebaseStorage } from "firebase/storage";
import { Firestore } from "firebase/firestore";
import { HttpsCallable } from "firebase/functions";

interface IFirebaseContext {
  app: FirebaseApp;
  auth: Auth;
  storage: FirebaseStorage;
  db: Firestore;
  functions: {
    analyzeImage: HttpsCallable;
    getPrompt: HttpsCallable;
    saveToGoogleSheet: HttpsCallable;
    getPrompts: HttpsCallable;
    createPrompt: HttpsCallable;
    updatePrompt: HttpsCallable;
    deletePrompt: HttpsCallable;
  };
}

export const FirebaseContext = createContext<IFirebaseContext>(
  {} as IFirebaseContext
);

export type { IFirebaseContext };
